import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import {
  EVENT_TYPE,
} from '../../../../constants/index';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: pxToRem(48),
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(64),
    },
    '& h2': {
      fontFamily: theme.custom.fontFamily.secondaryBoldCapt,
      letterSpacing: pxToRem(0),
      [theme.breakpoints.up('lg')]: {
        letterSpacing: pxToRem(-0.8),
      },
    },
    '& .card-description:not(.MuiBox-root)': {
      borderBottom: '0',
      boxShadow: theme.shadows[4],
    },
    '& .cta-wrap': {
      display: 'flex',
    },
    '& .seeAllBtn': {
      '& .MuiButton-endIcon': {
        backgroundColor: ({ pageContentType }) =>
          pageContentType === EVENT_TYPE && theme.mixins.DarkTurquoise(),
      },
      '&:hover .MuiButton-endIcon': {
        backgroundColor: theme.mixins.Black(),
      },
    }
  },
  spacing: {
    margin: `0 ${theme.spacing(-1.5)}`,
    width: 'auto',
    '&.listingBox': {
      listStyleType: 'none',
      paddingLeft: '0',
    },
    '& .MuiGrid-grid-lg-4': {
      padding: `0 ${theme.spacing(1.5)}`,
      marginBottom: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        flex: '0 0 83.333333%',
        maxWidth: '83.33%',
        padding: `0 ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        flex: '0 0 92%',
        maxWidth: '92%',
        padding: `0 ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
      },
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      margin: `0 ${theme.spacing(-3)}`,
      paddingTop: 0,
      paddingBottom: 0,
      ...theme.mixins.paddingLR(theme.spacing(1), theme.spacing(3)),
    },
  },
  alignRight: {
    textAlign: theme.mixins.textRight('right'),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bottomSpacing: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  '@global': {
    'html:lang(ar) .smart-list-wrapper .MuiChip-root': {
      whiteSpace: 'unset',
      height: 'auto',
    },
    'html:lang(ar) .smart-list-wrapper .MuiChip-root .MuiChip-label': {
      whiteSpace: 'unset',
    },
  },
}));

export default useStyles;
